<template>
  <v-app>
    <Header></Header>
    <side-bar></side-bar>
    <app-notifications></app-notifications>
    <v-main>
      <router-view></router-view>
    </v-main>
    <!-- <bottom-bar></bottom-bar> -->
  </v-app>
</template>

<script>
import AppNotifications from './components/notification/Notifications';

export default {
  name: "App",
  components: {
    Header: () => import("@/components/shared/_header_01.vue"),
    SideBar: () => import("@/components/shared/_drawer_01.vue"),
    BottomBar: () => import("@/components/shared/_bottom_01.vue"),
    AppNotifications,
  },
  data: () => ({
    //
  })
};
</script>
<style>
/* #app { */
/* Cor identidade visual do app - background */
/* background-color: var(--v-primary-base) !important; */
/* } */

html {
  /* Remove o scroll bar null */
  overflow-y: auto !important;
}
</style>
